<template>
  <div>
    <h2>Map and Co-Ordinates</h2>

    <p class="m-t-lg m-b-lg">
      Search for an address or click on the map to place the marker if you are unable to find the location. Please click and drag the marker if it is not placed correctly.
    </p>
    <div class="form-group">
      <label class="control-label">Search Address</label>
      <gmap-autocomplete
        :disabled="(locationNotEditable && notAlwaysEditable)"
        class="form-control"
        placeholder=""
        ref="autocomplete"
        @place_changed="handleAddressChanged">
      </gmap-autocomplete>
    </div>

    <div class="margin-20"></div>

    <div>
      <gmap-map
        ref="map"
        :center="center"
        :zoom="zoom"
        :options="{ streetViewControl: false }"
        @click="handleLocationMarker"
        style="width: 100%; height:400px">
        <gmap-marker
          v-if="locationHasLatitudeAndLongitude"
          :position="{ lat: latitude, lng: longitude }"
          @dragend="handleLocationMarker"
          :draggable="true">
        </gmap-marker>
      </gmap-map>
    </div>

    <div class="margin-20"></div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label">Longitude</label>
          <input type="text" class="form-control" :value="longitude" disabled>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label">Latitude</label>
          <input type="text" class="form-control" :value="latitude" disabled>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_LOCATION_ATTRIBUTE } from 'vx/mutations'
  import { mapState, mapMutations } from 'vuex'
  import { stateMapper, helpers } from 'mixins/locations'

  export default {
    mixins: [stateMapper, helpers],

    props: {
      alwaysEditable: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        zoom: 4,
        center: { lat: -27.0374585, lng: 133.2650289 }
      }
    },

    computed: {
      ...mapState('app', ['loading']),
      ...mapState('location', ['location']),

      /**
       * If the map is not always editable. Some parent components can override this
       * to force the map to be editable.
       *
       * @return boolean
       */
      notAlwaysEditable () {
        return !this.alwaysEditable
      }
    },

    watch: {
      /**
       * Watch the application loading, once loaded, we'll resize the map.
       *
       * @return void
       */
      loading (loading) {
        if (loading) return

        this.$nextTick(() => (this.$refs.map.resizePreserveCenter()))
      }
    },

    methods: {
      ...mapMutations('location', [SET_LOCATION_ATTRIBUTE]),

      /**
       * Handle changes to the address. Updates the lat/lng and zooms in on
       * the location.
       *
       * @param object place
       *
       * @return void
       */
      handleAddressChanged (place) {
        if (this.locationNotEditable && this.notAlwaysEditable) {
          return
        }

        if (place && place.geometry && place.geometry.location) {
          this.latitude = place.geometry.location.lat()
          this.longitude = place.geometry.location.lng()

          this.zoom = 10
          this.center = { lat: this.latitude, lng: this.longitude }
        }
      },

      /**
       * Handle the updating of the location marker either by dragging or by
       * clicking on the map.
       *
       * @param object event
       *
       * @return void
       */
      handleLocationMarker (event) {
        if (this.locationNotEditable && this.notAlwaysEditable) {
          return
        }

        if (event.latLng) {
          this.latitude = event.latLng.lat()
          this.longitude = event.latLng.lng()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Map.vue?5bc0142e